import React from 'react'
import { connect } from 'react-redux'
import { Layout } from 'antd'
import { withRouter } from 'react-router-dom'
import classNames from 'classnames'

const mapStateToProps = ({ settings }) => ({
  isCardShadow: settings.isCardShadow,
  isSquaredBorders: settings.isSquaredBorders,
  isBorderless: settings.isBorderless,
})

const ExternalLinkLayout = ({
  children,
  isCardShadow,
  isSquaredBorders,
  isBorderless,
}) => {
  return (
    <Layout>
      <Layout.Content>
        <div
          className={classNames( {
            cui__layout__squaredBorders: isSquaredBorders,
            cui__layout__cardsShadow: isCardShadow,
            cui__layout__borderless: isBorderless,
          })}
        >
          <div style={{backgroundColor: "#EEF1F6"}}>{children}</div>
        </div>
      </Layout.Content>
    </Layout>
  )
}

export default withRouter(connect(mapStateToProps)(ExternalLinkLayout))
